import { defineStore } from 'pinia';
import { ref } from 'vue';
import { HIDESAMPLEDATA } from '@/src/config';

export const useDataBrowserStore = defineStore('data-browser', () => {
  const hideSampleData = ref(HIDESAMPLEDATA);
  return {
    hideSampleData,
  };
});
